import React, {ReactNode} from "react";
import {isMobile} from "react-device-detect";
import {Col, Row} from "reactstrap";


export interface BrowserAdaptiveLayoutProps {
    children?: ReactNode | ReactNode[]
}


const BrowserAdaptiveLayout = ({children}: BrowserAdaptiveLayoutProps) => {


    if (isMobile === true) {
        // Renderizado directo
        return (
            <div className="mobile">
                {children}
            </div>
        );
    } else {
        // Renderizado con columnas de guarda
        return (
            <Row className="m-0 p-0 desktop">
                <Col xs={1} md={1} lg={2} xl={4} className="m-0 p-0">

                </Col>
                <Col xs={10} md={10} lg={8} xl={4} className="m-0 p-0">
                    {children}
                </Col>
                <Col xs={1} md={1} lg={2} xl={4} className="m-0 p-0">

                </Col>
            </Row>
        );
    }


}

export default BrowserAdaptiveLayout;